export const API_URL = "https://api.timetable.qubuilder.com";
